export default "__VITE_PUBLIC_ASSET__efe6ec03__"